import { api } from '@/services/api/client';
import type { NotificationPage, PendingNotifications } from './types';

/**
 * Notifications for the signed-in user.
 *
 * No call names the recipient: the server takes it from the token, so one
 * person cannot ask for another's.
 */
const BASE = '/notifications';

export const notificationsService = {
  /** Newest first. Paginated, so the envelope is kept for its `meta`. */
  list(
    query: { unreadOnly: boolean; limit: number; offset: number },
    signal?: AbortSignal,
  ): Promise<NotificationPage> {
    const params = new URLSearchParams({
      limit: String(query.limit),
      offset: String(query.offset),
    });
    if (query.unreadOnly) params.set('unreadOnly', 'true');
    return api.getEnveloped<NotificationPage>(
      `${BASE}?${params.toString()}`,
      signal ? { signal } : {},
    );
  },

  /** The unread total, for the sidebar badge. Counts only, never bodies. */
  pending(signal?: AbortSignal): Promise<PendingNotifications> {
    return api.get<PendingNotifications>(`${BASE}/pending`, signal ? { signal } : {});
  },

  /** Omitting `ids` marks everything unread as read. */
  markRead(ids?: string[]): Promise<{ marked: number }> {
    return api.post<{ marked: number }>(`${BASE}/read`, ids ? { ids } : {});
  },
};
